import {
  setLoading as setLoginLoading,
  setError as setLoginError,
} from './slice';
import { setUser } from '../Auth/slice';
import axiosInstance from '../../axiosInstance';

export const login = (data) => async (dispatch) => {
  try {
    dispatch(setLoginLoading(true));
    const { isPetOwner, ...formData } = data;
    const response = await axiosInstance.post('user/login', formData, { timeout: 3000 });
    const { user, token } = response.data.result;
    localStorage.setItem('token', token);
    localStorage.setItem('isPetOwner', isPetOwner);
    dispatch(setUser({ ...user, isPetOwner }));
    dispatch(setLoginError(null));
  } catch (err) {
    let errorMsg;
    if (err.response?.data) {
      ({ error: errorMsg } = err.response.data);
    } else {
      errorMsg = err.message;
    }
    dispatch(setUser(null));
    dispatch(setLoginError(errorMsg));
  } finally {
    dispatch(setLoginLoading(false));
  }
};

export const loginWithToken = () => async (dispatch) => {
  try {
    dispatch(setLoginLoading(true));
    const token = localStorage.getItem('token');
    if (!token) {
      dispatch(setUser(null));
      return;
    }
    const response = await axiosInstance.get('user/login', {
      headers: {
        // TODO: Change this to Bearer token when API supports
        Authorization: token,
      },
    });
    const isPetOwner =
      localStorage.getItem('isPetOwner') !== undefined ?
        JSON.parse(localStorage.getItem('isPetOwner')) :
        true;
    const { user: currentUser } = response.data.result;
    dispatch(setUser({ ...currentUser, isPetOwner }));
  } catch (err) {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('isPetOwner');
      dispatch(setUser(null));
    }
  } finally {
    dispatch(setLoginLoading(false));
  }
};
